import copy from "copy-to-clipboard";
import axios from "axios";
import { utils } from "./utils";
import Vue from "vue";
import { errorHandler } from "@/global-variables/errorHandler";

// const subscriptionApi = 'http://localhost:8282/SubscriptionManager/api/'
const subscriptionApi = "https://lytningtomcat.chrilantech.com/SubscriptionManager/api/";
window.subscriptionApi = subscriptionApi.endsWith("/")
  ? subscriptionApi
  : `${subscriptionApi}/`;
window.API = window.subscriptionApi;
window.copy = copy;
window.axios = axios;
window.errorHandler = errorHandler;
window.DPO_DISCOUNT = 0.1;
Vue.prototype.$utils = utils;
window.$utils = utils;
/*
{"status":"ERROR","httpStatus":400,"data":null,"error":{"status":400,"errorId":"de367c20-23b5-4963-a566-0f6cbb242501","category":"EXTERNAL","errorCode":"DPO:905","message":"DPO returned error: The transaction amount has exceeded your allowed transaction limit, please contact: support@directpay.online","fieldErrors":null,"timestamp":[2025,12,19,20,22,53,543311300]}}
*/
